// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.black-accordion{\n    background-color: rgb(56, 56, 56);\n    color: silver;\n    font-family: monospace;\n\n    border-radius: 0.7em !important;\n}\n\n.black-accordion > .accordion-button{\n    background-color: rgb(73, 73, 73);\n    color: silver;\n\n    border-radius: 0.7em !important;\n    padding: 10px;\n}", ""]);
// Exports
module.exports = exports;
